import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const CaptchaPage = ({ onSuccess }) => {
  const handleCaptcha = (value) => {
    if (value) {
      onSuccess(); // User passed the captcha
    }
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
      <h2>Verifying That You Are Not a Robot...</h2>
      <ReCAPTCHA
        sitekey="6LdC_DwrAAAAAPbHL8IM-KX-LOYpC0jkeCLZcEND"
        onChange={handleCaptcha}
      />
    </div>
  );
};

export default CaptchaPage;
